import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LineSpacingInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const LineSpacingInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ spacing, setSpacing ] = useState<number>(project.encoder.overlayLineSpacing);
  const debounce = 100;
  const min = 1;
  const max = 50;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = parseInt(data);

      if (value < min) {
        setSpacing(min);
      } else if (value > max) {
        value = max;
      }

      setSpacing(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayLineSpacing: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayLineSpacing: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setSpacing(project.encoder.overlayLineSpacing);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayLineSpacing]);

  return (
    <div className="line-spacing-input">
      <div className="input-title">
        {t('producer.inputs.line-spacing.title')}
        <Help
          title="Line Spacing"
          text="Allows you to increase the space between the lines of captions."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.line-spacing.placeholder"
        value={spacing.toString()}
        onChange={(value) => {setSpacing(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.line-spacing.footer')}</div>
    </div>
  );
};

export default React.memo(LineSpacingInput);
